module.exports = __webpack_public_path__ + "img/facebook.26bead30.svg";